@if (disputePojo) {
  <div id="main-content" class="wrapper has-padding"
    (focusout)="onFocusOutMainContent($event)">
    <form [formGroup]="disputeGroup" (ngSubmit)="onSubmit()">
      <div class = "maxwidth-750">
        <h1 class="bofa--heading is-4">Dispute Questionnaire</h1>
        <p class="bottom-space">Please complete the following information and submit your request to begin
        the dispute process.</p>
        <!-- Generate questions based on questionId recieved from ws -->
        @for (disputeQuestionAnswer of disputePojo.disputeQuestionAnswer; track disputeQuestionAnswer) {
          <div>
            @if (disputeQuestionAnswer.questionId == 3) {
              <div>
                <mat-form-field class="resize-dispute">
                  <mat-label id="dispute-question-label"><abbr title="required">* </abbr>{{disputeQuestionAnswer.questionName}}</mat-label>
                  <textarea class="textarea-resize" matInput maxlength="2000" required
                    formControlName="{{disputeQuestionAnswer.questionId}}" cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="50" aria-labelledby="dispute-question-label"></textarea>
                  <mat-hint align="end">
                    {{disputeGroup.get('3').value.length}} / 2000
                  </mat-hint>
                  <mat-error>
                  Invalid input. Please enter correct data.</mat-error>
                </mat-form-field>
              </div>
            }
            @if (disputeQuestionAnswer.questionId != 3) {
              <div class="bottom-space">
                <label class="minor-list-space" [attr.for]="'question-' + disputeQuestionAnswer.questionId"><abbr title="required">*
                </abbr>{{disputeQuestionAnswer.questionName}}
              </label>
              <mat-radio-group class="minor-radio-padding" required
                formControlName="{{disputeQuestionAnswer.questionId}}" [attr.id]="'question-' + disputeQuestionAnswer.questionId">
                <mat-radio-button class="minor-list-space radio-padding" matInput value="1" name="yes">Yes
                </mat-radio-button>
                <mat-radio-button class="minor-radio-padding" matInput value="2" name="no">No
                </mat-radio-button>
                @if (hasBeenSubmitted && disputeGroup.controls[disputeQuestionAnswer.questionId].hasError('required')) {
                  <mat-error
                    >
                    Please answer '{{disputeQuestionAnswer.questionName}}'
                  </mat-error>
                }
              </mat-radio-group>
            </div>
          }
          <br />
        </div>
      }
      @if (showAttachmentSection) {
        <div>
          <div>
            <mat-card appearance="outlined" class="af-mat-card mat-elevation-z">
              <mat-card-content>
                <p>
                  <span class="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="img-size" aria-label="information icon">
                      <g data-name="ICON OUTLINES">
                        <path fill="#012169" d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z" transform="translate(-2 -2)"/>
                        <path fill="#012169" d="M11.992,6.848a.632.632,0,0,0-.617.64.625.625,0,0,0,1.25,0A.635.635,0,0,0,11.992,6.848Z" transform="translate(-2 -2)"/>
                      <rect fill="#012169" x="9.5" y="7" width="1" height="8"/></g>
                    </svg>
                  </span>
                  Please attach
                  the documentation to this request by clicking the "Attach file" button below. If you
                have more than one document to attach, please click the "Attach file" button again. </p>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="is-stacked">
            <button type="button" class="bofa--button secondary outlined height-300-padding"
              color="primary"
              [disabled]="formSubmitted" (click)="openFileDialog(true)" aria-label="attach optional file">
              <span>
                <svg class="width-height-marginbottom-paddingleft" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" aria-label="document">
                  <g>
                    <rect fill="none" width="24" height="24"/>
                    <path d="M4.3,1.5v21H15l4.7-4.7V1.5H4.3z M5.3,2.5h13.4v14.6h-4.4v4.4h-9V2.5z M18,18.1l-2.7,2.7v-2.7H18z"/>
                    <rect x="7.5" y="11.5" width="8.9" height="1"/>
                    <rect x="7.5" y="7.1" width="8.9" height="1"/>
                    <rect x="7.5" y="15.9" width="5.6" height="1"/>
                  </g>
                </svg>
              </span>
              <span class = "padding-10"> Attach file</span>
            </button>
          </div>
          <div class="table-container bottom-space">
            <table mat-table [dataSource]="dataSource">
              <caption>Attachment table</caption>
              <ng-container matColumnDef="attachmtFileName">
                <td mat-cell *matCellDef="let element">
                  <span><a href="/bsiAF/api/downloadAsiAttachment?attachmentId={{element.attachmentId}}"
                    class="af-anchor" aria-label="download {{element.attachmtFileName}}"> {{element.attachmtFileName }}
                  </a></span>
                </td>
              </ng-container>
              <ng-container matColumnDef="remove">
                <td class="text-center" mat-cell *matCellDef="let element">
                  <div class="marginleft">
                    <button (keyup.enter)="removeAttachment(element.attachmentId)" (click)="removeAttachment(element.attachmentId)">
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="width-height-cursor" aria-label="remove icon">
                        <g data-name="24 x 24 BOX">
                          <rect fill="none" width="24" height="24"/>
                        </g>
                        <g data-name="ICON OUTLINE">
                          <polygon fill="#e31837" points="21 3.707 20.293 3 12 11.293 3.707 3 3 3.707 11.293 12 3 20.293 3.707 21 12 12.707 20.293 21 21 20.293 12.707 12 21 3.707"/>
                        </g>
                      </svg>
                      <span class="bofa--skiplink">remove attachment</span>
                    </button>
                  </div>
                </td>
              </ng-container>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          @if (noAttachment) {
            <mat-error>Please attach at least one file in response to
            'Can you provide additional documentation to help clarify the discrepancy identified?'</mat-error>
          }
        </div>
      }
    </div>
    <!-- Save / Save and Finish Later / Submit -->
    <div class="is-taller" class="paddingtop-50">
      <div class="level">
        <div class="level-region level-nav">
          <button type="button"
            class="bofa--button secondary dark-blue save-ie save-margin ui-font save-height"
          (click)="onClickSave()">Save</button>
          <button type="button" class="bofa--button secondary outlined ui-font"
            (click)="onClickSaveAndFinishLater()">Save
          and finish later</button>
        </div>
        <div class="level-item level-nav">
          <button type="submit" class="bofa--button primary large ui-font">Submit</button>
        </div>
      </div>
    </div>
  </form>
</div>
} @else {
  Loading Applicant User...
}
